import { AuthService } from '@dot-it/jml-lib'
import { SETTINGS } from './settings'

export function GET_REFRESH_URL(dtoType: string): string {
  return `/queue/${AuthService.getClientSessionId()}/${dtoType}/refresh`
}

export function GET_CLIENT_ID_AND_MESSAGES_URL(): string {
  return `/queue/${AuthService.getClientSessionId()}/messages`
}

export function GET_WATCH_MESSAGES_URL(): string {
  return `/queue/${SETTINGS.MAIN_REPLACEMENT_VARIABLES.LOGIN_NAME}/messages`
}

export function GET_WIZARD_ACTIONS(): string {
  return `/queue/${AuthService.getClientSessionId()}/wizard/notifications`
}
